import type { CSSProperties } from "react";

// Wordmark-only brand for Step 7.
// SVG lockups in handoff/brand/ will be wired later when the public/ asset
// pipeline lands. For now we render the wordmark in Bebas Neue with the
// signature 2px letter-spacing (per STRIKZA_DESIGN_SYSTEM.md §3).

const wrap: CSSProperties = {
  display: "inline-flex",
  alignItems: "baseline",
  gap: "8px",
  textDecoration: "none",
};

const word: CSSProperties = {
  fontFamily: "var(--sz-font-display)",
  fontSize: "28px",
  letterSpacing: "3px",
  color: "var(--sz-text-primary)",
  lineHeight: 1,
};

const dot: CSSProperties = {
  width: "6px",
  height: "6px",
  borderRadius: "50%",
  background: "var(--sz-amber)",
  display: "inline-block",
  alignSelf: "center",
  marginBottom: "4px",
};

export function Brand(): JSX.Element {
  return (
    <span style={wrap} aria-label="STRIKZA">
      <span style={word}>STRIKZA</span>
      <span style={dot} aria-hidden="true" />
    </span>
  );
}
